<template>

  <!-- Second Panel (Non existant for Logged-In users) -->
  <div v-if="!$variable('customer.loggedIn')"
    class="how-it-works-container">
    <HighlighterTitle
        :class="`section-title`"
        :highlighter-copy="liquid.title"
        :highlighter-size="`h2`"
        :highlighter-color="`accent03`"
      />
    <div class="steps-container">
      <a href="https://www.dormify.com/account/login" class="step">
        <div class="step-number">
          1
        </div>
        <div class="step-title">
          {{ liquid.step_title_1 }}
        </div>
        <div class="step-subtitle">
          {{ liquid.step_subtitle_1 }}
        </div>
        <img class="deco deco-1" src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/pin-cyan.png?v=1696598582" />
      </a>
      <a href="#start-earning" class="step">
        <div class="step-number">
          2
        </div>
        <div class="step-title">
          {{ liquid.step_title_2 }}
        </div>
        <div class="step-subtitle">
          {{ liquid.step_subtitle_2 }}
        </div>
        <img class="deco deco-2" src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/pin.png?v=1696598582" />
      </a>
      <a href="#points-description" class="step">
        <div class="step-number">
          3
        </div>
        <div class="step-title">
          {{ liquid.step_title_3 }}
        </div>
        <div class="step-subtitle">
          {{ liquid.step_subtitle_3 }}
        </div>
        <img class="deco deco-3" src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/pin-yellow.png?v=1696598582" />
      </a>
    </div>
  </div>

</template>

<script>

import { mapState, mapActions } from 'vuex'
import HighlighterTitle from '~global/highlighter-title/highlighter-title'
import Btn from '~global/btn/btn'

export default {
  name: 'LoyaltyLion',
  components: {
    HighlighterTitle,
    Btn
  },

  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
    liquid: {
      type: Object,
      default: ()=>({
        title: '',
        step_title_1: '',
        step_subtitle_1: '',
        step_title_2: '',
        step_subtitle_2: '',
        step_title_3: '',
        step_subtitle_3: ''
      }),
    }
  },

  data() {
    return {
    }
  },

  computed: {

    /**
     * Map Vuex state.
    */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

  },

  mounted() {

    this.setComponentState({ handle: 'loyalty-lion-steps', state: 'active' })

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          const navElement = document.getElementById("shopify-section-site-header");
          const navbarHeight = navElement.getBoundingClientRect().height;
          const offset = targetElement.getBoundingClientRect().top - navbarHeight;

          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          window.scrollTo({
            top: offset + scrollTop,
            behavior: 'smooth'
          });
        }
      });
    });


  },

  methods: {

    /**
     * Map Vuex actions.
    */
    ...mapActions({
      setComponentState: 'components/setState',
    }),

  },
}
</script>

<style lang="scss">
@import './loyalty-lion-steps';
</style>
